import React from "react";
import Select from "../../../../../../common/StyledSelect";
import CustomTextField from "../CustomTextField";
import { withStyles } from "@material-ui/core/styles";
import { MIN_VALUE } from "../../common/constants";
const styles = (theme) => ({
  fullWidth: { width: "100%" },
  flexRow: {
    display: "flex",
    direction: "column",
    "&>div": {
      flex: 1,
      width: "100%",
    },
  },
  huInput: {
    width: "38%",
  },
  packageTypeInput: {
    width: "60%",
  },
  flexRowWithSpacing: {
    display: "flex",
    justifyContent: "space-between",
  },
});

const PackageItems = ({
  classes,
  handleChange,
  errorInfo,
  editInfo,
  packageTypeList,
  index,
  packageCode,
}) => {
  return (
    <div className={classes.flexRowWithSpacing}>
      <CustomTextField
        className={classes.huInput}
        id="hu"
        handleChange={handleChange("hu", index)}
        value={editInfo.packagingItems[index].hu}
        error={errorInfo.packagingItemsErrorInfo[index]?.hu}
        label="HU"
        inputProps={{ min: MIN_VALUE.PICKUP_PRO_FORM.HU }}
        type="number"
      />
      <div className={`${classes.flexRow} ${classes.packageTypeInput}`}>
        <Select
          textFieldProps={{
            id: "packageCode",
            label: "Package Type",
            variant: "outlined",
            helperText: errorInfo.packagingItemsErrorInfo[index]?.packageCode,
          }}
          value={packageCode}
          error={Boolean(errorInfo.packagingItemsErrorInfo[index]?.packageCode)}
          onChange={handleChange("packageCode", index)}
          data={packageTypeList}
        />
      </div>
    </div>
  );
};

export default withStyles(styles)(PackageItems);
